import './welcome/welcome.page';
import './additional-inputs/additional-inputs.page';
import './application-form/application-form.page';